import { useEffect, useState } from "react";
import { TableColumnsType, Switch, message, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { paths, permissions } from "@/router";
import Button from "@components/Button";
import Table from "@components/Table";
import {
  useFetchTomUsersQuery,
  useSubAdminListMutation,
  useToggleSubAdminMutation,
} from "@/services/sub.admin";
import { ICombineReducerProps } from "@/store";
import { ISubAdminItem, ISubAdminReducer } from "@types";
import { ErrorServices } from "@/services";
import { checkPermission } from "@/utils";

const SubAdminsList = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const {
    data,
    isLoading: loader,
    refetch,
  } = useFetchTomUsersQuery({
    page,
    page_size: pageSize,
  });
  const { data: users, pagination } = data || {};

  const subAdminReducer: ISubAdminReducer = useSelector(
    (state: ICombineReducerProps) => state.subAdmin
  );
  const history = useHistory();
  const [getSubAdminList, { isLoading }] = useSubAdminListMutation();
  const [toggleSubAdmin] = useToggleSubAdminMutation();

  const columns: TableColumnsType<ISubAdminItem> = [
    {
      title: "NAME",
      key: "name",
      width: 130,
      render: ({ first_name, last_name }) => (
        <span>
          {first_name} {last_name}
        </span>
      ),
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
      width: 180,
    },
    {
      title: "PHONE NO",
      key: "phone_number",
      width: 130,
      render: ({ phone_number, phone_code }) => (
        <span>
          +{phone_code}
          {phone_number}
        </span>
      ),
    },
    ...((!checkPermission(permissions.ENABLE_DISABLE_TOM_USER)
      ? []
      : [
          {
            title: "Active/Inactive",
            width: 130,
            render: ({ id, first_name, last_name, is_active }: any) => {
              return (
                <Switch
                  defaultChecked={is_active}
                  onChange={(checked: boolean) =>
                    toggleSubAdminFromApi(
                      id,
                      `${first_name} ${last_name}`,
                      checked
                    )
                  }
                />
              );
            },
          },
        ]) as any),
    ...((!checkPermission(permissions.UPDATE_TOM_USER)
      ? []
      : [
          {
            title: "Action",
            key: "action",
            fixed: "right",
            width: 80,
            render: ({ id }: any) => {
              return (
                <div>
                  <span
                    className="table__action__btn"
                    onClick={() => history.push(`/tom-users/edit/${id}`)}
                  >
                    Edit
                  </span>
                </div>
              );
            },
          },
        ]) as any),
  ];

  useEffect(() => {
    getAdminListFromApi(page);
  }, [page]);

  const getAdminListFromApi = async (page: number) => {
    try {
      await getSubAdminList(page).unwrap();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const toggleSubAdminFromApi = async (
    id: string,
    name: string,
    is_active: boolean
  ) => {
    const isUserActive = is_active ? "active" : "inactive";
    try {
      await toggleSubAdmin({ id, is_active }).unwrap();
      getAdminListFromApi(page);
      message.success(`${name} has been successfully ${isUserActive}`);
    } catch (err: any) {
      ErrorServices(err);
    }
  };
  useEffect(() => {
    refetch();
  }, []);
  return (
    <>
      <div className="appTitle text-base font-[500] mx-5">Tom-Users</div>
      <div className="jobCreationBar  sticky top-0 z-10 bg-white px-14 py-6 rounded-lg flex justify-between items-center my-7">
        <div className="title text-themeBlue font-[500] text-3xl">
          Tom-Users
        </div>
        {checkPermission(permissions.CREATE_TOM_USER) && (
          <Button
            variant="add"
            onClick={() => history.push(paths.admin.settings.tom_users.create)}
          >
            Create Tom User
          </Button>
        )}
      </div>

      <div className="jobCreationListing bg-white px-14 py-6 rounded-lg">
        <Table
          // data={subAdminReducer?.list}
          // isLoading={isLoading}
          // columns={columns}
          // pagination={true}
          // count={subAdminReducer.pagination?.count}
          // onChangePage={setPage}
          // page={page}
          data={users}
          isLoading={isLoading}
          columns={columns}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          onPageSizeChange={setPageSize}
          page={page}
        />
      </div>
    </>
  );
};

export default SubAdminsList;
